import { BaseService } from "../../Base/BaseService";

export interface IBookingService {
  id: number;
  categoryId: number;
  name: string;
  price: number;
  durationMinutes: number;
  isActive: boolean;
}

export interface IAvailableDatesResponse {
  dates: string[];
}

export interface IAvailableSlot {
  startsAt: string;
  endsAt: string;
  time: string;
}

export interface IAvailableSlotsResponse {
  date: string;
  slots: IAvailableSlot[];
}

export interface ICreateBookingRequest {
  masterId: number;
  serviceId: number;
  startsAt: string;
  phone: string;
}

export interface ICreateBookingResponse {
  id: number;
  masterId: number;
  serviceId: number;
  startsAt: string;
  endsAt: string;
  phone: string;
  status: string;
}

export class CreateBookingService extends BaseService {
  public static async GetMasterServices(masterId: number): Promise<IBookingService[]> {
    return this.get(this.BaseApiUrl + `/masters/${masterId}/services`);
  }

  public static async GetAvailableSlots(masterId: number, serviceId: number, date: string): Promise<IAvailableSlotsResponse> {
    return this.get(this.BaseApiUrl + `/masters/${masterId}/available-slots?serviceId=${serviceId}&date=${date}`);
  }

  public static async CreateBooking(request: ICreateBookingRequest): Promise<ICreateBookingResponse> {
    return this.post(this.BaseApiUrl + "/bookings", request);
  }

  public static async GetAvailableDates(masterId: number, serviceId: number, from: string, to: string): Promise<IAvailableDatesResponse> {
    const params = new URLSearchParams();

    params.set("serviceId", String(serviceId));
    params.set("from", from);
    params.set("to", to);

    return this.get(this.BaseApiUrl + `/masters/${masterId}/available-dates?${params.toString()}`);
  }
}
